import React, { memo, useState } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { Paper, Stack, IconButton, Tooltip, Grid, Typography, TextField, Button, FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import { motion } from 'framer-motion'
import configServ from '../../../services/config'
import { useEffect } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import AlertDialog from "../../AlertDialog/AlertDialog";
import { useDispatch, useSelector } from 'react-redux'
import { triggerLoader } from '../../../redux/reducers/LoaderTrigger'
import RequiredLabel from '../../labels/RequiredLabel'
import Swal from 'sweetalert2'

//FUNCTION
const BrandCard = ({ isChanged, setIsChanged, editData, setEditData }) => {
    //#region code
    const dispatch = useDispatch();
    const { company_id } = useSelector((state) => state.GlobalVariables);
    const [formData, setFormData] = useState({
        status: true,
        isPrimary: false
    })
    const [isEdit, setIsEdit] = useState(false)
    const [validationErrors, setValidationErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target

        //Update form data
        setFormData((state) => ({
            ...state,
            [name]: value
        }));

        // Reset the validation error when the user starts typing
        if (validationErrors[name]) {
            setValidationErrors((prevValidationError) => ({
                ...prevValidationError,
                [name]: '',
            }));
        }
    }

    const handleChangeCheckbox = (e) => {
        const { name, checked } = e.target
        setFormData((state) => ({
            ...state,
            [name]: checked
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            
            dispatch(triggerLoader());

            const error = handleFormValidation();
            if (error === false) {
                return false;
            }
            setValidationErrors({});

            const dataToSend = {
                ...formData,
                company_id: company_id
            }

            if (!isEdit) {
                const res = await configServ.addBrand(dataToSend);
                if (res.status === 200) {
                    setIsChanged(!isChanged);
                    clear();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: res.message
                    });
                }
                else if (res.status === 400) {
                    Swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text: res.message || "Failed to create brand."
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: res.message || "Failed to create brand."
                    });
                }
            }
            else {
                const res = await configServ.editBrand(dataToSend);
                if (res.status === 200) {
                    setIsChanged(!isChanged);
                    clear();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: res.message
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: res.message || "Failed to update brand."
                    });
                }
            }
        }
        catch (err) {
            console.log(err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error has occurred."
            });
        }
        finally {
            dispatch(triggerLoader());
        }
    }

    useEffect(() => {
        if (Object.keys(editData).length !== 0) {
            setFormData(editData)
            setIsEdit(true)
            setFormData((prev) => ({
                ...prev,
                status: true
            }));
        }
    }, [editData]);

    const clear = () => {
        setFormData({
            status: true
        })
        setValidationErrors({})
        setIsEdit(false);
        setEditData({});
    }

    const handleFormValidation = () => {
        const errors = {}
        if (!formData.brand_name) {
            errors.brand_name = "required";
        }
        setValidationErrors(errors);
        return Object.values(errors).every((error) => error === "");
    }
    //#endregion

    return (
        <>
            <motion.div style={{ width: "100%", backgroundColor: "#e3f3fc", padding: 20, borderRadius: '10px', border: 'none' }}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
            >
                <Grid container alignItems="flex-end" justifyContent="flex-start" spacing={1}>
                    <Grid item xs={12} md={12} justifyContent={'flex-start'}>
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bolder' }}>Speciality Detail</Typography>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            id="brand_name"
                            name="brand_name"
                            label={<RequiredLabel label={'Speciality'} />}
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={formData.brand_name || ''}
                            onChange={handleChange}
                            error={validationErrors.brand_name}
                            sx={{ backgroundColor: 'white' }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            id="description"
                            name="description"
                            label="Description"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={formData.description || ''}
                            onChange={handleChange}
                            sx={{ backgroundColor: 'white' }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                            <FormControlLabel
                                name='status'
                                control={<Checkbox checked={Boolean(formData.status) || false} />}
                                onChange={handleChangeCheckbox}
                                label="Hide/Unhide"
                                style={{ marginRight: '20px' }}
                            />
                            <FormControlLabel
                                name='isPrimary'
                                control={<Checkbox checked={Boolean(formData.isPrimary) || false} />}
                                onChange={handleChangeCheckbox}
                                label="Default"
                            />
                        </FormGroup>
                    </Grid>

                </Grid>

                <Grid container spacing={2} justifyContent="space-between" px={2}>
                    <Grid
                        item
                        container
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                        mt={1}
                    >
                        <Stack direction={'row'} spacing={2}>
                            <Button
                                onClick={clear}
                                variant="contained"
                                color='secondary'
                                startIcon={<RotateLeftIcon />}
                            >
                                Reset
                            </Button>
                        {/* </Grid>
                        <Grid item> */}
                            <Button
                                onClick={handleSubmit}
                                autoFocus
                                variant="contained"
                                color={isEdit ? 'success' : 'primary'}
                                startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                            >
                                {isEdit ? "Update" : "Save"}
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </motion.div>

        </>
    )
}

export default memo(BrandCard);

